import Reactotron from 'reactotron-react-js';

Reactotron.configure().connect();
